
export default function InactiveLock() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] text-center p-8 animate-fade-in bg-white rounded-3xl border border-slate-100 shadow-sm">
      <div className="w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mb-6 border-4 border-red-50">
        <i className="ri-error-warning-fill text-5xl text-red-500"></i>
      </div>
      
      <h2 className="text-3xl font-bold text-slate-800 mb-4">
        Acceso Restringido: Empresa Inactiva
      </h2>
      
      <p className="text-slate-500 max-w-lg mb-8 text-lg leading-relaxed">
        Lo sentimos, tu acceso a las funcionalidades de Parqium ha sido suspendido temporalmente porque tu empresa no se encuentra activa.
      </p>

      <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 max-w-md w-full mb-10">
        <p className="text-slate-600 font-medium mb-4 italic">
          "Para recuperar el acceso y continuar gestionando tu parqueadero, por favor comunícate con soporte para más información."
        </p>
        <div className="flex items-center justify-center gap-4 text-slate-400 text-sm">
          <span className="flex items-center gap-1">
            <i className="ri-mail-line"></i>
            soporte@parqium.com
          </span>
          <span className="w-1 h-1 bg-slate-200 rounded-full"></span>
          <span className="flex items-center gap-1">
            <i className="ri-phone-line"></i>
            +57 300 8515255
          </span>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-4 w-full max-w-md">
        <button
          className="flex-1 py-4 bg-teal-600 hover:bg-teal-700 text-white rounded-xl shadow-lg shadow-teal-100 transition-all font-bold flex items-center justify-center gap-2"
          onClick={() => {
              window.open('https://wa.me/573008515255?text=Hola,%20mi%20empresa%20se%20encuentra%20INACTIVA%20en%20Parqium%20y%20necesito%20activarla.', '_blank');
          }}
        >
          <i className="ri-whatsapp-line text-xl"></i>
          Contactar Soporte
        </button>
        
        <button
          className="flex-1 py-4 bg-white border border-slate-200 text-slate-600 rounded-xl hover:bg-slate-50 transition-all font-bold flex items-center justify-center gap-2"
          onClick={() => window.location.reload()}
        >
          <i className="ri-refresh-line text-xl"></i>
          Reintentar
        </button>
      </div>

      <p className="mt-8 text-xs text-slate-400 flex items-center gap-1">
        <i className="ri-information-line"></i>
        Si crees que esto es un error, contacta a tu administrador de cuenta.
      </p>
    </div>
  );
}
